import { useState } from 'react';
import { Box } from '@mui/material';
import ListEvaluationTab from './ListEvaluationTab';
import SendEvaluationTab from './SendEvaluationTab';
import TabButton from './TabButton';

const AdminEvaluation = () => {
  const [tabActive, setTabActive] = useState(1);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          padding: '10px',
          backgroundColor: 'white',
        }}
      >
        <TabButton onClick={() => setTabActive(1)} isActive={tabActive === 1}>
          รายการประเมินความพึงพอใจ
        </TabButton>
        <TabButton onClick={() => setTabActive(2)} isActive={tabActive === 2}>
          ส่งแบบประเมินความพึงพอใจ
        </TabButton>
      </Box>

      {tabActive === 1 && <ListEvaluationTab />}
      {tabActive === 2 && <SendEvaluationTab />}
    </>
  );
};

export default AdminEvaluation;
